<ng-container *ngIf="!pdfLoaded">
  <vi-loader [isLoading]="!pdfLoaded" message="{{ progressPercentage }}%"></vi-loader>
</ng-container>
<div *ngIf="pdfLoaded" class="document-navigation">
  <ng-container *ngIf="allowNavigation">
    <button
      data-at-pdf-preview-previous-page-button
      mat-raised-button
      gtm="onPreviousPage"
      [gtmAction]="gtmAction"
      [gtmCategory]="gtmCategory"
      color="primary"
      [disabled]="!pdfLoaded || currentPage === 1"
      (click)="goToPreviousPage()"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="page-counter">{{ currentPage }} / {{ totalPages }}</div>
    <button
      data-at-pdf-preview-next-page-button
      mat-raised-button
      gtm="onNextPage"
      [gtmAction]="gtmAction"
      [gtmCategory]="gtmCategory"
      color="primary"
      [disabled]="!pdfLoaded || currentPage === totalPages"
      (click)="goToNextPage()"
    >
      <mat-icon>chevron_right</mat-icon>
    </button>
  </ng-container>
  <button
    *ngIf="allowZoomScale"
    data-at-pdf-zoom-mode-toggle
    mat-raised-button
    gtm="onZoomModeToggle"
    [gtmAction]="gtmAction"
    [gtmCategory]="gtmCategory"
    color="primary"
    (click)="toggleZoomMode()"
  >
    <mat-icon>{{ zoomScale === zoomScaleMode.pageFit ? 'zoom_out_map' : 'zoom_in_map' }}</mat-icon>
  </button>
</div>
<div class="wrapper">
  <pdf-viewer
    data-at-pdf-viewer
    [src]="src"
    [original-size]="originalSize"
    [zoom]="zoom"
    [zoom-scale]="zoomScale"
    [show-all]="showAll"
    [show-borders]="showBorders"
    [autoresize]="autoresize"
    [page]="currentPage"
    (on-progress)="onProgress($event)"
    (after-load-complete)="afterLoadComplete($event)"
    (pageChange)="pageChange($event)"
  ></pdf-viewer>
</div>
<div class="document-actions" *ngIf="allowDownload && totalPages">
  <button
    data-at-pdf-preview-download-button
    mat-raised-button
    gtm="onDownload"
    [gtmAction]="gtmAction"
    [gtmCategory]="gtmCategory"
    color="primary"
    (click)="downloadServiceInstructionFile(src)"
  >
    <mat-icon>download</mat-icon>
    <span>{{
      '+INSTALLATIONS.INSTALLATION.MAINTENANCE_CHECKLIST.DOWNLOAD_BUTTON' | translate
    }}</span>
  </button>
</div>
